function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "a",
  d: "M0 0h28v28H0z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("mask", {
  id: "b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#BCCCDC",
  d: "M11.46 15.375a.833.833 0 0 0-.59.247.827.827 0 0 0 0 1.174l4.724 4.704-4.723 4.704a.83.83 0 0 0 0 1.179.838.838 0 0 0 1.183-.005l5.372-5.35c.299-.298.247-.81-.06-1.115l-5.312-5.291a.843.843 0 0 0-.594-.247z",
  mask: "url(#b)",
  transform: "rotate(90 14.125 21.5)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#BCCCDC",
  d: "M11.46.375a.833.833 0 0 0-.59.247.827.827 0 0 0 0 1.174L15.595 6.5l-4.723 4.704a.83.83 0 0 0 0 1.179.838.838 0 0 0 1.183-.005l5.372-5.35c.299-.298.247-.81-.06-1.115L12.054.622a.843.843 0 0 0-.594-.247z",
  mask: "url(#b)",
  transform: "matrix(0 -1 -1 0 20.625 20.625)"
}));

var SvgSelector = function SvgSelector(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSelector, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/selector.5d6553a0.svg";
export { ForwardRef as ReactComponent };